import {Box, Typography} from "@mui/material"
import React from "react"

export default function reportNameColumn() {

	return {
		name: "reportName",
		label: "Report Name",
		options: {
			filterType: "textField",
			headerAlign: "left",
			customBodyRowRenderLite: (value) => (
				<Box sx={{display: "flex", alignItems: "center", justifyContent: "start"}}>
					<Typography sx={{fontWeight: "bold"}}>{value}</Typography>
				</Box>
			),
		},
	}
}
